import * as types from './actionTypes';

export const fetchMonthlyDeduction = (payload) => ({  
  type: types.PAYROLL_DEDUCTION_FETCH_MONTHLY_DEDUCTION,
  payload,
});

export const fetchMonthlyDeductionSuccess = (data) => ({
  type: types.PAYROLL_DEDUCTION_FETCH_MONTHLY_DEDUCTION_SUCCESS,
  payload: data,
});

export const fetchMonthlyDeductionFailure = (error) => ({
  type: types.PAYROLL_DEDUCTION_FETCH_MONTHLY_DEDUCTION_FAILURE,
  payload: error,
});

export const saveMonthlyDeduction = (payload) => ({
  type: types.PAYROLL_DEDUCTION_SAVE_MONTHLY_DEDUCTION,
  payload,
});

export const removeMonthlyDeduction = (payload) => ({
  type: types.PAYROLL_DEDUCTION_REMOVE_MONTHLY_DEDUCTION,
  payload,
});

export const removeMonthlyDeductionSuccess = (data) => ({
  type: types.PAYROLL_DEDUCTION_REMOVE_MONTHLY_DEDUCTION_SUCCESS,
  payload: data,
});

export const removeMonthlyDeductionFailure = (error) => ({
  type: types.PAYROLL_DEDUCTION_REMOVE_MONTHLY_DEDUCTION_FAILURE,
  payload: error,
});

export const changeMonthlyDeductionStatus = (payload) => ({
  type: types.PAYROLL_DEDUCTION_CHANGE_MONTHLY_DEDUCTION_STATUS,
  payload,
});

export const getDeductionTemplate = (payload) => ({
  type: types.PAYROLL_DEDUCTION_MONTHLY_TEMPLATE,
  payload,
});

export const importMonthlyDeduction = (payload) => ({
  type: types.PAYROLL_DEDUCTION_IMPORT_MONTHLY,
  payload,
});